/* eslint-disable import/prefer-default-export */
import getTooltipIcon from "./getTooltipIcon";

export const TOOLTIP_OFFSET = [0, 10];

export { getTooltipIcon };
